import GoogleMapsLoader from 'google-maps/lib/Google';
GoogleMapsLoader.KEY = 'AIzaSyDLGiAwjpjRkjibIiAGyPBRo7v6GFMYaTA';

export default function() {

  GoogleMapsLoader.load((google) => {

    function new_map( $el ) {
      // var
      var $markers = $el.find('.marker');

      // vars
      var args = {
        zoom		: 5,
        center		: new google.maps.LatLng(54.520946, -4.225404),
        mapTypeId	: google.maps.MapTypeId.ROADMAP,
        scrollwheel : false,
        styles: [
          {
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#f5f5f5',
              },
            ],
          },
          {
            'elementType': 'labels.icon',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#616161',
              },
            ],
          },
          {
            'elementType': 'labels.text.stroke',
            'stylers': [
              {
                'color': '#f5f5f5',
              },
            ],
          },
          {
            'featureType': 'administrative.land_parcel',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#bdbdbd',
              },
            ],
          },
          {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#eeeeee',
              },
            ],
          },
          {
            'featureType': 'poi',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#757575',
              },
            ],
          },
          {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#e5e5e5',
              },
            ],
          },
          {
            'featureType': 'poi.park',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#9e9e9e',
              },
            ],
          },
          {
            'featureType': 'road',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#ffffff',
              },
            ],
          },
          {
            'featureType': 'road.arterial',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#757575',
              },
            ],
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#dadada',
              },
            ],
          },
          {
            'featureType': 'road.highway',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#616161',
              },
            ],
          },
          {
            'featureType': 'road.local',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#9e9e9e',
              },
            ],
          },
          {
            'featureType': 'transit.line',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#e5e5e5',
              },
            ],
          },
          {
            'featureType': 'transit.station',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#eeeeee',
              },
            ],
          },
          {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#c9c9c9',
              },
            ],
          },
          {
            'featureType': 'water',
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'color': '#9e9e9e',
              },
            ],
          },
        ],
      }

      // create map
      var map = new google.maps.Map( $el[0], args);


      // add a markers reference
      map.markers = [];


      // add markers
      $markers.each(function(){

        add_marker( $(this), map );

      });


      // center map
      center_map( map );


      // return
      return map;

    }

    function add_marker( $marker, map ) {

      // var
      var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

      // custom icon
      var iconurl = $( '.acf-map' ).data('icon');


      var icon = iconurl + '/map-marker.png';

      // create marker
      var marker = new google.maps.Marker({
        position	: latlng,
        map			: map,
        icon: icon,
      });

      // add to array
      map.markers.push( marker );

      // if marker contains HTML, add it to an infoWindow
      if( $marker.html() )
      {
        // create info window
        var infowindow = new google.maps.InfoWindow({
          content		: $marker.html(),
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {

          infowindow.open( map, marker );

        });
      }

    }

    function center_map( map ) {
      if( map.markers.length === 0 ) {
        return;
      }

      // vars
      var bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each( map.markers, function( i, marker ){

        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

        bounds.extend( latlng );

      });

      // only 1 marker?
      if( map.markers.length === 1 ) {
        // set center of map
        map.setCenter( bounds.getCenter() );
      } else {
        // fit to bounds
        map.fitBounds( bounds );
      }
    }

    $('.acf-map').each(function(){

      // create map
      new_map( $(this) );

    });


  });

}



// WEBPACK FOOTER //
// ./scripts/app/map.js